export default ['pl', 'en'];
